import { useEffect } from "react";
import { useWalletConnection } from "@/hooks";
import { useQueryClient } from "@tanstack/react-query";
import { useWalletBalances } from "@/hooks";
import { QUERY_KEYS } from "@/config";

export function WalletBalancePrefetcher() {
    const { isConnected, address } = useWalletConnection();
    const queryClient = useQueryClient();

    // Prefetch all balances when wallet connects
    useWalletBalances();

    // Invalidate all wallet balances cache on disconnect
    useEffect(() => {
        if (!isConnected) {
            queryClient.invalidateQueries({ queryKey: QUERY_KEYS.TOKENS.BALANCE.LIST(address) });
            queryClient.invalidateQueries({ queryKey: QUERY_KEYS.POSITIONS.LOCK.LIST(address) });
        }
    }, [isConnected, address, queryClient]);

    // Invalidate balances when switching wallet
    useEffect(() => {
        if (address) {
            queryClient.invalidateQueries({ queryKey: QUERY_KEYS.TOKENS.BALANCE.LIST(address) });
            queryClient.invalidateQueries({ queryKey: QUERY_KEYS.POSITIONS.LOCK.LIST(address) });
        }
    }, [address, queryClient]);

    return null;
}
